module.exports = __webpack_public_path__ + "assets/icon-insulator-screwOn.c55e04a9.svg";